/** Plain-language labels for account fields the API returns as codes. */
export function planLabel(tier: string | null | undefined): string {
  return tier === 'premium' ? 'Premium' : 'Free'
}

export function planExplainer(tier: string | null | undefined): string {
  return tier === 'premium'
    ? 'You have access to every feature, including forecasts and AI assistants.'
    : 'Free covers your accounts and portfolio. Premium adds forecasts, AI assistants and more.'
}

export function experienceLabel(role: string | null | undefined): string {
  return role === 'expert' ? 'Expert (more detail and tools)' : 'Standard (simpler views)'
}

export const NOT_SET = 'Not set'
export const orNotSet = (v: string | null | undefined) => (v && v.trim() ? v : NOT_SET)

/** For editable rows: an empty value invites the tap instead of reading as a dead end. */
export const orTapToSet = (v: string | null | undefined) => (v && v.trim() ? v : 'Not set · tap to add')
